// The ? panel in the app: Communication's help (not in the generated guide file) and the ? on the Inbox.
import { EXTRA_ENTRIES, PAGE_GUIDE } from '../lib/guideSearch'
import { COMMS_GUIDE, COMMS_PAGE_GUIDE } from './guideEntries'
EXTRA_ENTRIES.push(...COMMS_GUIDE)
Object.assign(PAGE_GUIDE, COMMS_PAGE_GUIDE)
